import React from "react";
import { CrudModal } from "../modals/CrudModal";
import { CrudDrawerProps } from "./CrudDrawer.types";

export const CrudDrawer: React.FC<CrudDrawerProps> = (props) => {
  return <CrudModal {...props} asDrawer />;
};
